import React from "react";
import KirecCozucu from "../Components/product/KirecCozucu";
import PageHeader from "../Components/common/PageHeader";
import SEO from "../Components/common/SEO";
import { t } from "i18next";

function KirecCozucuPage() {
    const siteUrl = 'https://seymenkimya.com';
    const productUrl = `${siteUrl}/kireccozucu`;
    const productImage = `${siteUrl}/assets/images/20-kg/1.webp`;

    const productStructuredData = {
        '@context': 'https://schema.org',
        '@type': 'Product',
        'name': 'Kireç Çözücü',
        'description': 'Güçlü formülü ile kireç ve mineral birikintilerini etkili şekilde çözen profesyonel temizlik ürünü. Banyo, mutfak ve endüstriyel kullanım için ideal.',
        'image': [productImage],
        'brand': { 
            '@type': 'Brand', 
            'name': 'Seymen Kimya' 
        },
        'manufacturer': {
            '@type': 'Organization',
            'name': 'Seymen Kimya'
        },
        'category': 'Temizlik Ürünleri',
        'offers': {
            '@type': 'Offer',
            'priceCurrency': 'TRY',
            'price': 1,
            'availability': 'https://schema.org/InStock',
            'url': productUrl,
            'seller': {
                '@type': 'Organization',
                'name': 'Seymen Kimya'
            }
        },
        'aggregateRating': {
            '@type': 'AggregateRating',
            'ratingValue': '4.8',
            'ratingCount': '127'
        }
    };

    return (
        <>
            <SEO
                title="Kireç Çözücü | Güçlü Kireç Temizleyici - Seymen Kimya"
                description="Profesyonel kireç çözücü ile kireç ve mineral birikintilerini kolayca temizleyin. Banyo, mutfak ve endüstriyel kullanım için güvenli ve etkili çözüm."
                canonical={productUrl}
                type="product"
                image={productImage}
                structuredData={productStructuredData}
            />
            <PageHeader title={t("KİREÇ ÇÖZÜCÜ")} />
            <KirecCozucu />  
        </>
    );
}

export default KirecCozucuPage;